import React from 'react'
import { ProjectDescription } from './ProjectDescription'
import { Scene } from './Scene'
import { PoiDescription } from './PoiDescription'

export function ProjectSceneView() {
  return (
    <>
      <Scene />
      <ProjectDescription />
      <PoiDescription />
    </>
  )
}
